import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';

import {RecentlyInactive} from './RecentlyInactive';

export default connect(
  createStructuredSelector({
    featureFlag: variablesFeatureFlag,
  }),
)(RecentlyInactive);
